export default "__VITE_ASSET__C$RUR5Lu__"